var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AxiosStorage } from './storage';
export class BrowserAxiosStorage extends AxiosStorage {
    /**
     * @param storage Any browser storage, like sessionStorage or localStorage
     * @param prefix The key prefix to use on all keys.
     */
    constructor(storage, prefix = BrowserAxiosStorage.DEFAULT_KEY_PREFIX) {
        super();
        this.storage = storage;
        this.prefix = prefix;
        this.find = (key) => __awaiter(this, void 0, void 0, function* () {
            const json = this.storage.getItem(`${this.prefix}:${key}`);
            return json ? JSON.parse(json) : { state: 'empty' };
        });
        this.set = (key, value) => __awaiter(this, void 0, void 0, function* () {
            return this.storage.setItem(`${this.prefix}:${key}`, JSON.stringify(value));
        });
        this.remove = (key) => __awaiter(this, void 0, void 0, function* () {
            return this.storage.removeItem(`${this.prefix}:${key}`);
        });
    }
}
BrowserAxiosStorage.DEFAULT_KEY_PREFIX = 'a-c-i';
